module.exports = __webpack_public_path__ + "static/media/do.06e1cfe3.svg";